import React from "react";
import { Paragraph, useColorTokens } from "@tvg/design-system";
import { RaceListItem } from "@tvg/ts-types/Race";
import RaceChangeIndicator from "./RaceChangeIndicator";
import { RaceDetail } from "./styled-components";

interface RaceDetailsListProps {
  raceDetails: RaceListItem[];
  isLogged?: boolean;
}

const RaceDetailsList = ({ raceDetails, isLogged }: RaceDetailsListProps) => {
  const colorTokens = useColorTokens();

  return (
    <>
      {raceDetails.map((detail, index: number) => (
        <RaceDetail key={index.toString()}>
          <Paragraph
            qaLabel={`runners-number-${index.toString()}`}
            fontFamily="regular"
            fontSize="s"
            color={colorTokens.content.subtle}
          >
            {`${detail.value}`}
          </Paragraph>
          {isLogged && <RaceChangeIndicator detail={detail} />}
        </RaceDetail>
      ))}
    </>
  );
};

export default RaceDetailsList;
